<div class="dialog-alert-update dialog-new">
	<div class="header-dialog">
		<div class="back-title">
			<h3 class="title">
				{{ "APPLICATION_PWA.ALERTS_PAGE.UPDATE" | translate }}
			</h3>
		</div>
	</div>
	<div class="body-dialog">
		<p class="description">
			{{ "APPLICATION_PWA.ALERTS_PAGE.NEED_UPDATE_TEXT" | translate }}
		</p>
		<div class="buttons">
			<tc-new-button
				class="btn-action"
				[btnType]="'button'"
				[attributeVariantsType]="attributeVariantsType.Flat"
				[hierarchyType]="hierarchyType.Primary"
				[sizeType]="sizeType.LG"
				[isRound]="true"
				[submitSubscription]="updateSubscription"
				(clickBtn)="updateNow()"
			>
				<ng-container dataBtn>
					{{ "APPLICATION_PWA.ALERTS_PAGE.UPDATE" | translate }}
				</ng-container>
			</tc-new-button>
			<tc-new-button
				class="btn-action btn-call"
				[btnType]="'button'"
				[attributeVariantsType]="attributeVariantsType.Stroked"
				[hierarchyType]="hierarchyType.Secondary"
				[sizeType]="sizeType.LG"
				[isRound]="true"
				(clickBtn)="close()"
			>
				<ng-container dataBtn> {{ "APPLICATION_PWA.ALERTS_PAGE.LATER" | translate }} </ng-container>
			</tc-new-button>
		</div>
	</div>
</div>
